export function validateVerificationCodeInput(code) {
  if (!code) {
    return "Please enter the verification code.";
  }
  return null;
}

export function parseVerificationCodeError(error) {
  const status = error?.status ?? error?.response?.status;
  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }
  switch (status) {
    case 404:
      return "Invalid verification code.";
    case 400:
      return "Invalid request. Please check your input.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please try again later.";
    default:
      return "An error occurred. Please try again.";
  }
}
